import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  accountEmailById,
  avatarUrlById,
  fullNameById,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withProps} from '/util/selector.util';

import Avatar from './Avatar';

export default connect(
  createStructuredSelector({
    avatarUrl: withProps({coachId: userId})(avatarUrlById),
    avatarKey: withProps({coachId: userId})(accountEmailById),
    fullName: withProps({coachId: userId})(fullNameById),
  }),
)(Avatar);
